import {Observable, timer, EMPTY} from 'rxjs';
import i18next from 'i18next';

import {combineEpics} from 'web-app/util/redux-observable';
import * as AccountItemObservables from 'web-app/react/entities/account-items/epics';
import generateUUID from 'web-app/util/uuid';
import * as GlobalEventActions from 'web-app/react/global-event/actions';
import {NO_ITEMS_TO_INVOICE_ERROR_CODE} from 'web-app/react/plans/debt-report/batch-invoice/constants';

import * as Actions from './actions';

const previewInvoice = action$ =>
    action$
        .ofType(Actions.previewInvoice.type)
        .debounce(({payload}) => (payload.initialFetch ? EMPTY : timer(500)))
        .mergeMap(({payload}) => {
            const requestId = generateUUID();

            return Observable.concat(
                Observable.of(Actions.storeInvoicePreviewId.action(requestId)),
                AccountItemObservables.previewInvoiceObservable(
                    payload.institutionId,
                    payload.billPayerId,
                    payload.invoice,
                    {suppressErrors: true},
                )
                    .flatMap(action => {
                        return [
                            action,
                            action && action.payload && action.payload.result && action.payload.result.invoice
                                ? Actions.previewInvoiceSuccess.action({
                                      requestId,
                                      result: action.payload.result,
                                  })
                                : Actions.previewInvoiceAborted.action({
                                      requestId,
                                      warnings: action.payload.result.warnings,
                                  }),
                        ];
                    })
                    .catch(error => {
                        if (error && error.errorCode === NO_ITEMS_TO_INVOICE_ERROR_CODE) {
                            return Observable.of(Actions.previewInvoiceAborted.action({requestId}));
                        } else {
                            const errorMessage = error ? error.error : i18next.t('somethingWentWrong');
                            return Observable.concat(
                                Observable.of(GlobalEventActions.updateError.action(errorMessage)),
                                Observable.of(Actions.previewInvoiceFailed.action({requestId, error: errorMessage})),
                            );
                        }
                    }),
            );
        });

export default combineEpics(previewInvoice);
